module.exports = __webpack_public_path__ + "img/copy-btn.893caa5c.png";